import {
  Typography,
  useTheme,
  Chip,
  Stack,
  Card,
  CardMedia,
  CardContent,
  Avatar,
} from "@mui/material";
import { AccessTime, DateRange } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

// Blog Card Component - Simple & Clean
export default function BlogCard({ post }) {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Card
      onClick={() => navigate("mmmmmmmm")}
      sx={{
        borderRadius: 4,
        overflow: "hidden",
        transition: "all 0.3s ease",
        cursor: "pointer",
        bgcolor: "background.paper",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: theme.shadows[8],
        },
      }}
      elevation={0}
    >
      {/* Image */}
      <CardMedia
        component="img"
        height="200"
        image={post.image}
        alt={post.title}
        sx={{
          objectFit: "cover",
          transition: "transform 0.5s ease",
          "&:hover": {
            transform: "scale(1.05)",
          },
        }}
      />

      <CardContent sx={{ p: 2.5, flex: 1 }}>
        {/* Category Chip */}
        <Chip
          label={post.category}
          size="small"
          sx={{
            bgcolor: `${theme.palette.primary.main}15`,
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: "0.7rem",
            mb: 1.5,
            height: 24,
          }}
        />

        {/* Title */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            mb: 1,
            direction: "rtl",
            lineHeight: 1.4,
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            width: "100%",
            fontSize: "1rem",

            textOverflow: "ellipsis",
          }}
        >
          {post.title}
        </Typography>

        {/* Description - short preview */}
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mb: 2,
            direction: "rtl",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            fontSize: ".8rem",
            width: "100%",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {post.description}
        </Typography>

        {/* Footer - author & date */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" alignItems="center" gap={"4px"}>
            <DateRange sx={{ fontSize: 14, color: "text.secondary" }} />
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              {post.date || "1401/13/2"}
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" gap={"4px"}>
            <AccessTime sx={{ fontSize: 14, color: "text.secondary" }} />
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              {post.readTime} دقیقه
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
